import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarGrupoModal from "./criar/CriarGrupoModal.vue";
import EditarGrupoModal from "./editar/EditarGrupoModal.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { GrupoService } from "../../services/GrupoService";
import { ExercicioService } from "../../services/ExercicioService";
import TextField from "../../components/fields/textField/TextField.vue";

export default {
    name: "GerenciarGrupos",
    components: {
        Breadcrumb,
        CriarGrupoModal,
        EditarGrupoModal,
        StandardPagination,
        ActionButtons,
        TextField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Grupos',
                disabled: true
            }
        ],
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1 },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px', priority: 2 },
            { text: 'Código Grupo', align: 'center', value: 'codigo_grupo', width: '150px', priority: 1 },
            { text: 'Descrição', align: 'center', value: 'descricao', width: '300px', priority: 1 },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        filters: {
            codigoGrupoFilter: '',
            descricaoGrupoFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        showFilters: true
    }),
    computed: {
        isAllSelected() {
            return this.itemSelected.length === this.items.length && this.items.length > 0;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            return this.baseHeaders;
        }
    },
    created() {
        this.listarGruposPaginado();
        this.listarExerciciosSelect();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarGruposPaginado();
        },
        'filters.codigoGrupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarGruposPaginado();
            }
        },
        'filters.descricaoGrupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarGruposPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarGruposPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarGruposPaginado();
            }
        }
    },
    methods: {
        async listarGruposPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await GrupoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os grupos.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os grupos:', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        async destroyGrupos() {
            try {
                const ids = this.itemSelected.map(grupo => grupo.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("grupos[]", id);
                });

                const response = await GrupoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os grupos.');
                }

                this.listarGruposPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os grupos:', error);
            }
        },
        async activateGrupos() {
            try {
                const ids = this.itemSelected.map(grupo => grupo.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("grupos[]", id);
                });

                const response = await GrupoService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os grupos.');
                }

                this.listarGruposPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os grupos:', error);
            }
        },
        async deactivateGrupos() {
            try {
                const ids = this.itemSelected.map(grupo => grupo.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("grupos[]", id);
                });

                const response = await GrupoService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os grupos.');
                }

                this.listarGruposPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os grupos:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },
        closeEditDialog() {
            this.modalEdit = false;
        },
        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            this.filters.codigoGrupoFilter
            ? filter.append(
                "codigo",
                this.filters.codigoGrupoFilter
            )
            : null;

            this.filters.descricaoGrupoFilter
                ? filter.append(
                    "descricao",
                    this.filters.descricaoGrupoFilter
                )
                : null;

            this.filters.exercicioFilter
                ? filter.append(
                    "exercicio",
                    this.filters.exercicioFilter
                )
                : null;

            this.filters.statusFilter !== null
                ? filter.append(
                    "ativo",
                    this.filters.statusFilter
                )
                : null;

            return filter;
        },
        
        navigateToCreate() {
            this.$router.push('/grupos/criar');
        },
        
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/grupos/editar/${this.itemSelected[0].id}`);
            }
        },
        
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },

        handlePageChanged(newPage) {
            this.page = newPage;
            this.listarGruposPaginado();
        },

        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarGruposPaginado();
        },

        toggleSelectAll() {
            if (this.itemSelected.length === this.items.length) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },

        getRowClass(item) {
            return item.ativo ? 'active-row' : 'inactive-row';
        },

        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }

    }
};
